export default __webpack_public_path__ + "static/59d02457e9821e54b1e46f001776a43a.svg";